module.exports = __webpack_public_path__ + "img/w3_viewed_light.22659644.png";